import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useI18n } from "../i18n/I18nContext";

export default function SourcesDialog({ open, onClose }) {
  const { t } = useI18n();

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[70] flex items-stretch justify-end"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          data-testid="sources-dialog"
        >
          <button
            type="button"
            aria-label="close"
            onClick={onClose}
            className="absolute inset-0"
            style={{ background: "rgba(26,24,22,0.45)" }}
            data-testid="sources-backdrop"
          />
          <motion.aside
            className="relative w-full md:w-[640px] h-full overflow-y-auto"
            style={{ background: "var(--bg)" }}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="p-8 md:p-14">
              <div className="flex items-start justify-between mb-10">
                <span className="mono" style={{ color: "var(--faded)" }}>
                  〇三  ─  {t.sources.title}
                </span>
                <button
                  type="button"
                  onClick={onClose}
                  className="mono under-link"
                  style={{ color: "var(--ink)" }}
                  data-testid="sources-close-btn"
                >
                  {t.sources.close}  ×
                </button>
              </div>

              <h3 className="display text-[28px] md:text-[36px] mb-10" style={{ fontWeight: 400 }}>
                {t.sources.subtitle}
              </h3>

              <ol className="border-t hair">
                {t.sources.list.map((entry, idx) => (
                  <li key={idx} className="grid grid-cols-12 gap-3 border-b hair py-5">
                    <span className="col-span-2 mono pt-1" style={{ color: "var(--faded)" }}>
                      f.{String(idx + 1).padStart(2, "0")}
                    </span>
                    <p
                      className="col-span-10 text-[14px] md:text-[15px] leading-relaxed"
                      style={{ color: "var(--ink)", fontWeight: 300 }}
                    >
                      {entry}
                    </p>
                  </li>
                ))}
              </ol>

              <p className="mono mt-10" style={{ color: "var(--faded)", lineHeight: 1.55 }}>
                {t.colophon.disclaimer}
              </p>
            </div>
          </motion.aside>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
